import { render, staticRenderFns } from "./BtnExportarPagamentos.vue?vue&type=template&id=6d2c0d3b"
import script from "./BtnExportarPagamentos.vue?vue&type=script&lang=js"
export * from "./BtnExportarPagamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports